import { FilterFn } from "@tanstack/react-table";
import { normalizeString } from "./common";

export const createdByFilter: FilterFn<any> = (row, columnId, value) => {
  const creator = row.original.resource?.creation_data?.creator ?? "";

  return normalizeString(creator).includes(normalizeString(value));
};
